export default "__VITE_ASSET__Db64RMtA__"